// Old /interview/:sessionId/practice route — redirects to the new tab-aware
// detail page so existing bookmarks / browser history still work.
//
// All practice logic lives in components/domain/PracticeForSession.tsx and is
// rendered as a tab inside InterviewSession.tsx.

import { Navigate, useParams } from 'react-router-dom';

export default function Practice() {
  const { sessionId } = useParams<{ sessionId: string }>();
  const target = sessionId
    ? `/interview/${encodeURIComponent(sessionId)}?tab=practice`
    : '/interview';
  return <Navigate to={target} replace />;
}
